import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// English translations
const commonEN = require('./locales/en/common.json');
const navigationEN = require('./locales/en/navigation.json');
const dashboardEN = require('./locales/en/dashboard.json');
const productsEN = require('./locales/en/products.json');
const ordersEN = require('./locales/en/orders.json');
const usersEN = require('./locales/en/users.json');
const biddingEN = require('./locales/en/bidding.json');
const paymentsEN = require('./locales/en/payments.json');
const categoriesEN = require('./locales/en/categories.json');
const brandsEN = require('./locales/en/brands.json');
const shippingEN = require('./locales/en/shipping.json');
const validationEN = require('./locales/en/validation.json');
const loginEN = require('./locales/en/login.json');
const addProductEN = require('./locales/en/addProduct.json');
const attributesEN = require('./locales/en/attributes.json');
const attributeValuesEN = require('./locales/en/attributeValues.json');
const campaignsEN = require('./locales/en/campaigns.json');
const messagingEN = require('./locales/en/messaging.json');
const settingsEN = require('./locales/en/settings.json');
const boutiquesEN = require('./locales/en/boutiques.json');

// French translations
const commonFR = require('./locales/fr/common.json');
const navigationFR = require('./locales/fr/navigation.json');
const dashboardFR = require('./locales/fr/dashboard.json');
const productsFR = require('./locales/fr/products.json');
const ordersFR = require('./locales/fr/orders.json');
const usersFR = require('./locales/fr/users.json');
const biddingFR = require('./locales/fr/bidding.json');
const paymentsFR = require('./locales/fr/payments.json');
const categoriesFR = require('./locales/fr/categories.json');
const brandsFR = require('./locales/fr/brands.json');
const shippingFR = require('./locales/fr/shipping.json');
const validationFR = require('./locales/fr/validation.json');
const loginFR = require('./locales/fr/login.json');
const addProductFR = require('./locales/fr/addProduct.json');
const attributesFR = require('./locales/fr/attributes.json');
const attributeValuesFR = require('./locales/fr/attributeValues.json');
const campaignsFR = require('./locales/fr/campaigns.json');
const messagingFR = require('./locales/fr/messaging.json');
const settingsFR = require('./locales/fr/settings.json');
const boutiquesFR = require('./locales/fr/boutiques.json');

const resources = {
  en: {
    common: commonEN,
    navigation: navigationEN,
    dashboard: dashboardEN,
    products: productsEN,
    orders: ordersEN,
    users: usersEN,
    bidding: biddingEN,
    payments: paymentsEN,
    categories: categoriesEN,
    brands: brandsEN,
    shipping: shippingEN,
    validation: validationEN,
    login: loginEN,
    addProduct: addProductEN,
    attributes: attributesEN,
    attributeValues: attributeValuesEN,
    campaigns: campaignsEN,
    messaging: messagingEN,
    settings: settingsEN,
    boutiques: boutiquesEN,
  },
  fr: {
    common: commonFR,
    navigation: navigationFR,
    dashboard: dashboardFR,
    products: productsFR,
    orders: ordersFR,
    users: usersFR,
    bidding: biddingFR,
    payments: paymentsFR,
    categories: categoriesFR,
    brands: brandsFR,
    shipping: shippingFR,
    validation: validationFR,
    login: loginFR,
    addProduct: addProductFR,
    attributes: attributesFR,
    attributeValues: attributeValuesFR,
    campaigns: campaignsFR,
    messaging: messagingFR,
    settings: settingsFR,
    boutiques: boutiquesFR,
  },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    lng: 'fr', // Default language is French
    fallbackLng: 'fr', // Fallback to French if translation missing
    defaultNS: 'common',
    ns: [
      'common',
      'navigation',
      'dashboard',
      'products',
      'orders',
      'users',
      'bidding',
      'payments',
      'categories',
      'brands',
      'shipping',
      'validation',
      'login',
      'addProduct',
      'attributes',
      'attributeValues',
      'campaigns',
      'messaging',
      'settings',
      'boutiques',
    ],
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ['localStorage'], // Only check localStorage, don't use navigator
      caches: ['localStorage'],
      lookupLocalStorage: 'i18nextLng',
      // Don't use navigator language - always default to French
    },
  });

export default i18n;
